import React from 'react';
import { useState, useEffect } from 'react';
import FormHeader from '../presentational/FormHeader';
import FormBody from '../presentational/FormBody';
import Box from '@material-ui/core/Box';
import Alert from '@material-ui/lab/Alert';
import IconButton from '@material-ui/core/IconButton';
import Collapse from '@material-ui/core/Collapse';
import CloseIcon from '@material-ui/icons/Close';
import axios from 'axios';
import { Redirect } from "react-router-dom";
import CircularProgress from '@material-ui/core/CircularProgress'
import Typography from '@material-ui/core/Typography'
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
    loader: {
        textAlign: 'center',
    },
}));

export default function CLEForm(props) {
    const classes = useStyles();
    const [formValues, setFormValues] = useState({
        sponsor: "Case Western Reserve University School of Law",
        sponsorId: "4004",
        title: props.Title,
        creditHrs: props.CLECredit,
        CLECreditTypeId: props.CLECreditTypeId,
        CLECreditTypeName: props.CLECreditTypeName,
        CLEId: props.vid,
        type: "Online CLE",
        activityCode1: "",
        activityCode2: "",
        address1: "",
        address2: "",
        attorneyRegistration: "",
        city: "",
        classYear: "",
        depthOfCoverage: "",
        email: "",
        firstName: "",
        heardAboutThisEvent: "",
        lastName: "",
        moreValuable: "",
        phone: "",
        practicalRelevance: "",
        practiceOrganization: "",
        programComment: "",
        programConveyPracticalInfo: "",
        programHoldInterest: "",
        programIncreaseKnowledge: "",
        signature: "",
        speakerEvaluation: "",
        speakerEvaluationNames: "",
        specificSubjectsCovered: "",
        state: "",
        therCLEPrograms: "",
        yearsInPractice: "",
        zip: "",
        userAgent: window.navigator.userAgent
    })
    const [errors, setErrors] = useState({})
    const [errorMessage, setErrorMessage] = useState("");
    const [open, setOpen] = useState(false)
    const [submitButtonDisabled, setSubmitButtonDisabled] = useState(false)
    const [confirmAttorneyRegistration, setConfirmAttorneyRegistation] = useState("")
    const [video, setVideo] = useState(null)
    const [formSubmitted, setFormSubmitted] = useState(null)
    const submitForm = () => {
        var tempErrors
        var errorElement
        if (formValues.signature == null || formValues.signature === "") {
            tempErrors = { ...tempErrors, signature: "Please enter provide your digital signature" }
            errorElement = document.getElementById("attorneyRegistration")
        }
        if (formValues.attorneyRegistration == null || formValues.attorneyRegistration === "") {
            tempErrors = { ...tempErrors, attorneyRegistration: "Please enter attorney registration number" }
            errorElement = document.getElementById("attorneyRegistration")
        }
        if (formValues.attorneyRegistration != confirmAttorneyRegistration) {
            tempErrors = { ...tempErrors, attorneyRegistration: "Your attorney registration numbers don't match" }
            errorElement = document.getElementById("attorneyRegistration")
        }
        if (formValues.activityCode2 == null || formValues.activityCode2 === "") {
            tempErrors = { ...tempErrors, activityCode2: "Please enter activity code 2" }
            errorElement = document.getElementById("activityCode2")
        }
        if (formValues.activityCode1 == null || formValues.activityCode1 === "") {
            tempErrors = { ...tempErrors, activityCode1: "Please enter activity code 1" }
            errorElement = document.getElementById("activityCode1")
        }
        if (formValues.email == null || formValues.email === "" || !(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(formValues.email))) {
            tempErrors = { ...tempErrors, email: "Please enter a valid email" }
            errorElement = document.getElementById("email")
        }
        if (formValues.lastName == null || formValues.lastName === "") {
            tempErrors = { ...tempErrors, lastName: "Please enter your last name" }
            errorElement = document.getElementById("lastName")
        }
        if (formValues.firstName == null || formValues.firstName === "") {
            tempErrors = { ...tempErrors, firstName: "Please enter your first name" }
            errorElement = document.getElementById("firstName")
        }
        if (errorElement) {
            errorElement.scrollIntoView()
        }
        if (tempErrors) {
            setErrors(tempErrors)
        }
        else {
            setSubmitButtonDisabled(true);

            console.log(`Fetching (POST) '/law/api/online-cle/law_CLEFormSubmissions/${props.vid}'`);
            axios.post(`/law/api/online-cle/law_CLEFormSubmissions/${props.vid}`, {
                data: {
                    Title: props.Title,
                    CLEId: props.vid,
                    Date: null,
                    Type: "Online CLE",
                    AttorneyNumber: formValues.attorneyRegistration,
                    AttorneyName: formValues.firstName + " " + formValues.lastName,
                    FormData: JSON.stringify(formValues)
                },
                activityCode: formValues.activityCode1 + formValues.activityCode2,
                UserToken: props.authToken,
                Email: formValues.email,
                GradYear: formValues.classYear
            })
                .then(res => {
                    setSubmitButtonDisabled(false);

                    console.log(res)
                    if (formValues.classYear) {
                        setFormSubmitted(true)
                    }
                    else {
                        console.log("/law/api/online-cle/onlineCLE_Videos/route/" + res.data.SubmissionGuid)
                        console.log(res.data)
                        window.location.href = "/law/api/online-cle/onlineCLE_Videos/route/" + res.data.SubmissionGuid;
                    }
                })
                .catch(function (error) {
                    setSubmitButtonDisabled(false);

                    if (error.response.status == 400) {
                        console.log(error.response)
                        setErrorMessage(error.response.data.Message)
                        setOpen(true)
                        window.scrollTo(0, 0)
                    }
                })
        }
    }
    const handleChange = (event) => {
        setFormValues({ ...formValues, [event.target.id]: event.target.value });
    };
    const handleConfirmAttorneyChange = (event) => {
        setConfirmAttorneyRegistation(event.target.value)
    }
    useEffect(() => {
        console.log(`Fetching (POST) '/law/api/online-cle/OnlineCLE_Videos/video/${props.vid}'`);
        axios.post(`/law/api/online-cle/OnlineCLE_Videos/video/${props.vid}`, {
            token: props.authToken
        })
            .then(res => {
                console.log(res.data)
                setVideo(res.data)
                if (res.data.FormData != null) {
                    if (JSON.parse(res.data.FormData) != null) {
                        setConfirmAttorneyRegistation(JSON.parse(res.data.FormData).attorneyRegistration)
                    }
                    setFormValues(JSON.parse(res.data.FormData))
                }
            })
    }, [props.authToken])
    if (formSubmitted || (video && video.QuikPayId)) {
        return (<Redirect to="/law/online-cle/"></Redirect>)
    }
    else if (video && formValues) {
        return (
            <React.Fragment>
                <Box m={4}>
                    <Collapse in={open}>
                        <Alert
                            severity="error"
                            id="errorMessage"
                            action={
                                <IconButton
                                    aria-label="close"
                                    color="inherit"
                                    size="small"
                                    onClick={() => {
                                        setOpen(false);
                                    }}
                                >
                                    <CloseIcon fontSize="inherit" />
                                </IconButton>
                            }
                        >
                            {errorMessage}
                        </Alert>
                    </Collapse>
                    <FormHeader Title={props.Title} CLECredit={props.CLECredit}></FormHeader>
                    <FormBody submitForm={submitForm} formValues={formValues} handleChange={handleChange} handleConfirmAttorneyChange={handleConfirmAttorneyChange} confirmAttorneyRegistration={confirmAttorneyRegistration} submitButtonDisabled={submitButtonDisabled} errors={errors}></FormBody>
                </Box>
            </React.Fragment>
        );
    }
    else {
        return (
            <Box className={classes.loader}>
                <Typography variant="h6" component="h2">Getting Form Data</Typography>
                <CircularProgress />
            </Box>
        )
    }
}